var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pro-form__base-layout"},_vm._l((_vm.fields),function(field,i){return _c('el-form-item',_vm._b({key:field[_vm.fieldKey || 'id'] || i},'el-form-item',field.formItemProps,false),[_vm._t("default",null,{"field":field})],2)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }